//	import '@fortawesome/fontawesome-free/js/all'
//	import 'paper'
//	import 'sumoselect'
//	import 'slick-carousel'
//	import 'iscroll'
//window.$ = require('jquery');
//import Swiper from 'swiper';